module.exports = __webpack_public_path__ + "media/images/demo/m_site_template/ODYJQKKX-1183fdb80f9292f37909c817c7506dcd.png";